<template>
  <div class="password-change-container">
    <div class="password-card">
      <div class="password-title">修改密码</div>
      <div class="password-tip">
        <i class="el-icon-warning-outline"></i>
        为了您的账户安全，建议定期更换密码。
      </div>
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        class="password-form"
      >
        <div class="input-row">
          <label class="input-label">原密码</label>
          <el-form-item prop="oldpw" class="input-item">
            <el-input
              type="password"
              v-model="ruleForm.oldpw"
              placeholder="请输入原密码"
              clearable
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
        </div>
        <div class="input-row">
          <label class="input-label">新密码</label>
          <el-form-item prop="newpw" class="input-item">
            <el-input
              type="password"
              v-model="ruleForm.newpw"
              placeholder="请输入新密码"
              clearable
              prefix-icon="el-icon-key"
            ></el-input>
          </el-form-item>
        </div>
        <div class="input-row">
          <label class="input-label">确认新密码</label>
          <el-form-item prop="checknewpw" class="input-item">
            <el-input
              type="password"
              v-model="ruleForm.checknewpw"
              placeholder="请再次输入新密码"
              clearable
              prefix-icon="el-icon-check"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button
            class="password-btn"
            type="primary"
            @click="Confirm('ruleForm')"
            :loading="loading"
            round
            block
            >确定修改</el-button
          >
        </el-form-item>
      </el-form>
      <div class="password-safety">
        <div class="safety-title">
          <i class="el-icon-info"></i> 密码安全建议：
        </div>
        <ul class="safety-list">
          <li>密码长度建议8-16位，包含字母、数字和符号的组合。</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken } from "../../utils/auth";
export default {
  data() {
    var validoldpw = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原密码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (
        !/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-z]|[A-Z]|[0-9]){6,}$/.test(
          value
        )
      ) {
        callback("密码为8-16位字母、数字或符号至少2种组合");
      } else {
        if (this.ruleForm.checknewpw !== "") {
          this.$refs.ruleForm.validateField("checknewpw");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newpw) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      ruleForm: {
        oldpw: "",
        newpw: "",
        checknewpw: ""
      },
      rules: {
        oldpw: [{ validator: validoldpw, trigger: "blur" }],
        newpw: [{ validator: validatePass, trigger: "blur" }],
        checknewpw: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  methods: {
    Confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          // 构建修改密码的参数
          const params = {
            token: this.$store.state.token,
            oldpw: this.ruleForm.oldpw,
            newpw: this.ruleForm.newpw,
            account: this.$store.state.account // 添加账户信息
          };
          
          this.axios
            .changepw(params)
            .then(res => {
              this.loading = false;
              if (res.data.code == 200) {
                this.$message.success("修改成功,请重新登录");
                removeToken();
                location.reload();
              } else {
                this.$message.error(res.data.message || "修改失败");
              }
            })
            .catch(err => {
              this.loading = false;
              this.$message.error("网络错误，请稍后重试");
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.password-change-container {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
}
.password-card {
  width: 500px;
  max-width: 96vw;
  margin-top: 50px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 38px 32px 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  transition: width 0.2s, padding 0.2s;
}
.password-title {
  font-size: 24px;
  font-weight: 700;
  color: #f1787f;
  margin-bottom: 12px;
  letter-spacing: 1px;
  text-align: center;
}
.password-tip {
  width: 100%;
  background: #fff7e7;
  color: #f7b267;
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 18px;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
}
.password-form {
  width: 100%;
  margin-bottom: 10px;
}
.input-row {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
.input-label {
  width: 100px;
  min-width: 80px;
  font-size: 16px;
  color: #333;
  font-weight: 600;
  text-align: right;
  margin-right: 18px;
  letter-spacing: 1px;
}
.input-item {
  flex: 1;
  margin-bottom: 0 !important;
}
.password-btn {
  width: 100%;
  font-size: 16px;
  height: 44px;
  border-radius: 8px;
  background: #f1787f;
  border: none;
  color: #fff;
  font-weight: 600;
  box-shadow: none;
  transition: background 0.2s;
  margin-top: 8px;
}
.password-btn:hover {
  background: #f58f86;
}
.password-safety {
  width: 100%;
  background: #f8f8fa;
  border-radius: 8px;
  padding: 16px 18px 10px 18px;
  box-sizing: border-box;
}
.safety-title {
  color: #f1787f;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.safety-list {
  padding-left: 18px;
  color: #888;
  font-size: 14px;
  margin: 0;
}
.safety-list li {
  margin-bottom: 2px;
  line-height: 1.7;
}
@media (max-width: 600px) {
  .password-card {
    padding: 16px 4vw 16px 4vw;
    max-width: 98vw;
    margin-top: 24px;
  }
  .password-title {
    font-size: 20px;
  }
  .password-tip {
    font-size: 14px;
    padding: 8px 8px;
  }
  .password-safety {
    padding: 10px 8px 6px 8px;
  }
  .input-row {
    flex-direction: column;
    align-items: stretch;
  }
  .input-label {
    text-align: left;
    margin-bottom: 4px;
    margin-right: 0;
    font-size: 15px;
  }
}
</style>
